<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseballMatchSummary',
  computed: {
    data() {
      return this.update.Data;
    },
    innings() {
      return this.update.Data.Innings.sort(
        (a: { InningNumber: number }, b: { InningNumber: number }) => {
          if (a.InningNumber > b.InningNumber) return 1;
          if (a.InningNumber < b.InningNumber) return -1;
          if (a.InningNumber < b.InningNumber) return 0;
        }
      );
    },
    teams() {
      return this.fixture.Name.split(' v ');
    },
  },
  props: ['update', 'fixture'],
});
</script>

<template>
  <section v-if="update">
    <div
      :class="{
        'grid grid-flow-col grid-rows-[1fr_1fr_1fr_1fr] w-max': true,
        '[grid-template-columns:repeat(auto-fit,max-content)]': true,
        'text-center border-gray-500': true,
        'custom-cells m-auto my-2': true,
      }"
    >
      <div class="h row-span-2">Матч идет</div>
      <div class="b text-lg row-span-2 place-content-center">
        <i class="pi pi-check text-green-500 text-lg" v-if="data.BallInPlay !=='No'" />
        <i class="pi pi-times text-red-500 text-lg" v-else />
      </div>

      <div class="h row-span-2">Фаза</div>
      <div class="b text-lg row-span-2 place-content-center">{{ data.Phase }}</div>

      <div class="!text-left h row-span-2">Игроки</div>
      <div class="text-gray-500 !text-left">{{ teams[0] }}</div>
      <div class="b text-gray-500 !text-left">{{ teams[1] }}</div>

      <template v-for="one in innings">
        <div class="h col-span-5">
          Иннинг {{ one.InningNumber }}
          <i class="pi pi-stopwatch text-green-500 text-sm" v-if="(one.Status !== 'Finished') && data.BallInPlay !== 'No'" />
        </div>

        <div class="h t cursor-help" title="Hits">H</div>
        <div class="t">{{ one.Hits.Home }}</div>
        <div class="b t">{{ one.Hits.Away }}</div>

        <div class="h t cursor-help" title="Left on base">L</div>
        <div class="t">{{ one.LeftOnBase.Home }}</div>
        <div class="b t">{{ one.LeftOnBase.Away }}</div>

        <div class="h cursor-help" title="Runs">R</div>
        <div class="">{{ one.Runs.Home }}</div>
        <div class="b">{{ one.Runs.Away }}</div>

        <div class="h t cursor-help" title="Outs">O</div>
        <div class="t">{{ one.Outs.Home }}</div>
        <div class="b t">{{ one.Outs.Away }}</div>

        <div class="h t cursor-help" title="Errors">E</div>
        <div class="t">{{ one.Errors.Home }}</div>
        <div class="b t">{{ one.Errors.Away }}</div>
      </template>

      <div class="r h row-span-2">
        Счет матча
        <br />
        <span class="text-gray-500 text-sm">Total Runs</span>
      </div>
      <div class="r font-mono text-lg">{{ data.TotalRuns.Home }}</div>
      <div class="r b font-mono text-lg">{{ data.TotalRuns.Away }}</div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.custom-cells {
  & > div {
    @apply px-3 pt-2 pb-1 text-lg;
    @apply border border-gray-500;

    &:not(.r) {
      @apply border-r-0;
    }

    &:not(.b) {
      @apply border-b-0;
    }

    &.h {
      @apply bg-gray-300 dark:bg-gray-700 place-content-center;
    }

    &.t {
      @apply px-1 text-xs place-content-center text-gray-500;
    }
  }
}
</style>
